// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f9-a";
export var fulfillmentFormRail = "_f9-9";
export var headerTitleRow = "_f9-c";
export var orderDetailsWrapper = "_f9-7";
export var paymentInformationGrid = "_f9-h";
export var paymentSummaryColumn = "_f9-i";
export var shipmentContainer = "_f9-b";
export var shipmentDetailsMainPane = "_f9-8";
export var shipmentNavigationCard = "_f9-5";
export var shipmentNavigationRail = "_f9-3";
export var shipmentNavigationRailHeader = "_f9-4";
export var shipmentSummaryFact = "_f9-e";
export var shipmentSummaryGrid = "_f9-d";
export var shipmentSummaryMetadataRow = "_f9-f";
export var shipmentSummaryTags = "_f9-g";
export var shipmentWorkspace = "_f9-0";
export var shipmentWorkspaceBody = "_f9-2";
export var shipmentWorkspaceContent = "_f9-6";
export var shipmentWorkspaceHeader = "_f9-1";